var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon33(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7623 7.81473L8.64482 5.68848H13.5623V8.75098H14.8748V4.37598H8.64482L10.7623 2.24973L9.83482 1.31348L6.12482 5.03223L9.83482 8.75098L10.7623 7.81473ZM10.4998 12.251C9.98064 12.251 9.47312 12.4049 9.04144 12.6934C8.60977 12.9818 8.27331 13.3918 8.07463 13.8714C7.87595 14.3511 7.82397 14.8789 7.92525 15.3881C8.02654 15.8973 8.27655 16.365 8.64366 16.7321C9.01077 17.0992 9.4785 17.3493 9.9877 17.4505C10.4969 17.5518 11.0247 17.4998 11.5044 17.3012C11.984 17.1025 12.394 16.766 12.6824 16.3343C12.9709 15.9027 13.1248 15.3952 13.1248 14.876C13.1248 14.1798 12.8483 13.5121 12.356 13.0198C11.8637 12.5275 11.196 12.251 10.4998 12.251ZM2.62482 9.62598V20.126H18.3748V9.62598H2.62482ZM16.6248 16.626C16.1607 16.626 15.7156 16.8104 15.3874 17.1385C15.0592 17.4667 14.8748 17.9118 14.8748 18.376H6.12482C6.12482 17.9118 5.94044 17.4667 5.61225 17.1385C5.28407 16.8104 4.83895 16.626 4.37482 16.626V13.126C4.83895 13.126 5.28407 12.9416 5.61225 12.6134C5.94044 12.2852 6.12482 11.8401 6.12482 11.376H14.8748C14.8748 11.8401 15.0592 12.2852 15.3874 12.6134C15.7156 12.9416 16.1607 13.126 16.6248 13.126V16.626Z",
    fill: "#FF5E43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon33);
export default __webpack_public_path__ + "static/media/icon33.7e4a7fd550c6cc4b54a4e8d99bd5a6b8.svg";
export { ForwardRef as ReactComponent };